import {createStyles} from "@mantine/core";

export const useStyles = createStyles((theme) => ({
    title: {
        color: theme.colorScheme === 'dark' ? '#fff' : '#000',
    }
}));
  